module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "textcenterb"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm05"
    }
  }), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('em', [_vm._v("For two of the Other Women in my life: my agent, Jane Otte, and my editor, Susanne Kirk, who forgive my literary trespasses but don’t let me get away with them.")])]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-884a6c1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm05.vue
// module id = 66
// module chunks = 0